module.exports = __webpack_public_path__ + "img/video-selfie-image.6f917623.svg";